import axiosService from './axios-service';
import { NotificationResponseDto } from '../dtos/notification.dto';
import { AxiosHeaders } from 'axios';

class NotificationService {
    public getNotificationList = async (customerId: number, serviceId?: number): Promise<{ userNotifications: NotificationResponseDto[] }> => {
        const suffix = serviceId ? `/service/${serviceId}` : '';
        const url = `/api/notifications/customer/${customerId}${suffix}`;
        const result = await axiosService.get(url,false);
        return result?.data;
    };

    public sendMixpanelAlert = async (message: string) => {
        const headers: AxiosHeaders = new AxiosHeaders();
        headers.setContentType('text/plain');
        await axiosService.post(`/api/notifications/alert/mixpanel`, message, true, {headers});
    };
}

const notificationService = new NotificationService();
export default notificationService;
